import { render } from "./UserLogs.vue?vue&type=template&id=5175d66d&scoped=true"
import script from "./UserLogs.vue?vue&type=script&lang=js"
export * from "./UserLogs.vue?vue&type=script&lang=js"

import "./UserLogs.vue?vue&type=style&index=0&id=5175d66d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Management_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5175d66d"]])

export default __exports__